const modules = [
  {
    module: "Users",
    completed: true,
    classname: "mb2 f5-l fw5 mt3",
    id: 1,
  },
  {
    module: "Customers",
    completed: true,
    classname: "mb2 f5-l fw5 mt3",
    id: 2,
  },

  {
    module: "Parts",
    completed: true,
    classname: "mb2 f5-l fw5 mt3",
    id: 3,
  },
  {
    module: "SDS (Safety Data Sheets)",
    completed: true,
    classname: "mb2 f5-l fw5 mt3",
    id: 4,
  },
  {
    module: "Inventory",
    completed: true,
    classname: "mb2 f5-l fw5 mt3",
    id: 5,
  },

  {
    module: "Ordering",
    completed: true,
    classname: "mb2 f5-l fw5 mt3",
    id: 6,
  },

  {
    module: "Labeling",
    classname: "mb2 f5-l fw5 mt3",
    id: 7,
  },

  {
    module: "Supply Chain",
    classname: "mb2 f5-l fw5 mt3",
    id: 8,
  },
  {
    module: "Reporting",
    classname: "mb2 f5-l fw5 mt3",
    id: 9,
  },

  {
    module: "Dashboard",
    classname: "mb2 f5-l fw5 mt3",
    id: 10,
  },
];

export default modules;
